import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  public log(message: unknown, ...args: unknown[]): void {
    console.log(message, ...args);
  }

  public warn(message: unknown, ...args: unknown[]): void {
    console.warn(message, ...args);
  }

  public error(message: unknown, ...args: unknown[]): void {
    console.error(message, ...args);
  }
}
